// 添加防抖标志变量
let isProcessing = false;


$(document).on('click', '#product-grid .swatchList .item .itemBox__select', function () {
  // 防抖检查：如果正在处理则直接返回
  if (isProcessing) return;

  // 新增状态检查：直接通过属性判断
  if ($(this).prop('disabled')) return;

  // 标记开始处理
  isProcessing = true;

  const $this = $(this);
  const id = $this.closest('.item').data('id');

  // 激活状态处理
  if ($this.closest('.item').hasClass('active')) {
    $(`.swatchCart .cartList .item[data-item-id="${id}"]`).trigger('click');
    isProcessing = false; // 恢复状态
    return;
  }

  // 购物车数据处理。判定见 utils.js 的 isSwatchLineItem —— 按 handle 不按标题，
  // 否则 10 个 $5.00 的付费色卡本会被算进免费额度里。
  const swatchItems = cartData.items.filter(isSwatchLineItem);

  let totalQuantity = 0;
  let itemExists = false;

  swatchItems.forEach(item => {
    totalQuantity += item.quantity;
    console.log(item.id, id);
    if (item.id === id) itemExists = true;
  });

  // 上限检查：数满 10 片就不再加，并且必须让用户看到原因。
  // 右侧清单里的 .isFull 是常驻说明，但它可能被滚动到视口外（尤其手机），
  // 所以同时弹一次浮层提示 —— 见 assets/swatch-limit.js。
  $('.swatchCart .isFull').toggle(totalQuantity >= 10);
  if (totalQuantity >= 10) {
    if (typeof swatchLimitNotice === 'function') swatchLimitNotice();
    isProcessing = false;
    return;
  }

  // 禁用界面元素（售罄格子本来就 disabled，排除掉，结束时不能把它们一起解开）
  const $buttons = $('.swatchList .item:not([sold_out]) .itemBox__select');
  $buttons.attr('loading', true).prop('disabled', true);

  // 处理存在商品的情况
  if (!itemExists) {
    addMultipleToCart([{ id, quantity: 1 }])
      .then(async (results) => {
        // ⚠ addMultipleToCart 失败也会正常 resolve（把错误放进 results），
        // 不检查的话变体售罄/无效时照样关弹窗、开抽屉、刷选中态，
        // 用户看不到任何失败原因，.catch 永远不会执行。
        const failed = (results || []).find((r) => r.status !== 'success');
        if (failed) {
          // 只取 Shopify JSON 里的说明。断网 / 超时 / 非 JSON 响应时 failed.data
          // 是 undefined，why 为空，交给 swatchAddError 回落到通用文案 ——
          // 绝不能传给 swatchLimitNotice，那会显示成"你已经加满 10 片"。
          const why = (failed.data && (failed.data.description || failed.data.message)) || '';
          if (typeof swatchAddError === 'function') swatchAddError(why);
          throw new Error('Add swatch failed: ' + (why || failed.httpStatus || 'unknown'));
        }

        // 这里原来写的是裸变量 cartDrawer —— 全局根本没有这个变量
        // （只在本文件另一个处理函数里有个同名局部 const），所以每次加购都在
        // 这一行抛 ReferenceError，被下面的 .catch 吞成一句 "Add to cart failed"，
        // 后面的 swatchCartChange2 也就从来没跑过。改成就地取元素。
        // onCartDrawerUpdate 内部把 fetch 错误吞掉了，返回 false 表示抽屉没更新上，
        // 这时候不能开抽屉 —— 否则用户看到的是"加购成功但没这件商品"的抽屉。
        const drawerItems = document.querySelector('cart-drawer-items');
        if (drawerItems && typeof drawerItems.onCartDrawerUpdate === 'function') {
          if ((await drawerItems.onCartDrawerUpdate()) === false) {
            window.location.reload();
            return;
          }
        }
        // addMultipleToCart 现在会等购物车数据同步完才 resolve，这里不用再猜时机
        swatchCartChange2();
      })
      .catch((err) => console.error('Add to cart failed', err))
      .finally(() => {
        // 无论成功失败都恢复状态
        $buttons.removeAttr('loading').prop('disabled', false);
        isProcessing = false;
      });
  } else {
    // 如果商品已存在，直接恢复状态
    $buttons.removeAttr('loading').prop('disabled', false);
    isProcessing = false;
  }
});

// 小样页的移动端断点。和 assets/products-grid-swatch.css 里的 960px 保持一致 ——
// 两边不一致会出现"样式按移动端画、行为按桌面端走"的错位。
function isMobileSwatch () {
  return window.matchMedia('(max-width: 960px)').matches;
}

/* ------------------------------------------------------------------
   View Details：和 PDP 同一个小样弹窗（2026-10-15 统一）

   弹窗外壳在 section 里（snippets/swatch-sheet.liquid，mode: collection），开关、多选、上限、加入、
   移除、焦点和滚动锁都在 assets/products-grid-swatchpopup.js（PDP 同一份）。这里只做一件事：
   按点的那张卡生成颜色格子，再打开弹窗并定位到点的那个颜色。

   格子是**整块面料的全部颜色**，不跟 Color 筛选 / 搜索 / 一排上限收窄：弹窗是「这块布有哪些颜色」，
   一眼看全、可以一次挑几个，和 PDP 的弹窗一致；收窄只管网格怎么摆。
   旧轮播（buildSwatchPopup / 箭头 / 滑动 / 计数 / 自己的 Tab 圈定和滚动锁）已整体删除，
   样式文件 products-grid-swatchpopup1.css 也不再加载。
   ------------------------------------------------------------------ */
const SWATCH_SHEET_BADGE = '<svg width="12" height="12" viewBox="0 0 12 12" fill="none"><path d="M2.5 6.2 5 8.5l4.5-5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';

// 这个颜色能买到的成品：卡片头部 "Available as" 的链接里，.item[data-shop] 记着有这个颜色的那几个
// （Liquid 按成品的颜色选项算好，见 snippets/products-grid-swatch.liquid），链接补 ?selectcolor= 让 PDP 预选。
function swatchShopLinksFor (card, item, color) {
  const shopLinks = card.querySelectorAll('.swatchShop .swatchShop__link');
  return (item.dataset.shop || '').split(',').filter(Boolean).map(function (index) {
    const source = shopLinks[Number(index)];
    if (!source) return null;
    // PDP 按 selectcolor 预选颜色（大小写不敏感），用变体原名，不用 data-color 的小写版
    const url = new URL(source.href, location.origin);
    url.searchParams.set('selectcolor', color);
    const track = source.getAttribute('click-data');
    return {
      href: url.pathname + url.search,
      label: source.textContent.trim(),
      title: source.title || '',
      track: track ? track.replace('-shop-', '-' + color + '-shop-') : ''
    };
  }).filter(Boolean);
}

// 按卡片生成弹窗格子。属性口径和 PDP 的 Liquid 格子一致（sections/main-product.liquid），弹窗脚本只认这些：
// data-id / data-color / data-name / data-fabric（面料图）/ data-curtain（成品图）/ data-sold-out。
// 用 DOM API 拼，颜色名不进 innerHTML。
function fillSwatchSheet (sheet, card) {
  const holder = sheet.querySelector('[data-swatch-tiles]');
  if (!holder) return;
  const tiles = [];
  card.querySelectorAll('.swatchList > .item').forEach(function (item) {
    const name = (item.querySelector('.productTitle')?.textContent || item.dataset.color || '').trim();
    const soldOut = item.hasAttribute('sold_out');
    const img = item.dataset.img || '';
    const tile = document.createElement('button');
    tile.type = 'button';
    tile.className = 'swatch-sheet__tile' + (soldOut ? ' is-sold-out' : '');
    tile.setAttribute('data-swatch-tile', '');
    tile.dataset.id = item.dataset.id;
    tile.dataset.color = (item.dataset.color || name).toLowerCase();
    tile.dataset.name = name;
    tile.dataset.fabric = img ? imgUrlSize(img, 480) : '';
    tile.dataset.curtain = item.dataset.curtain || '';
    if (soldOut) {
      tile.setAttribute('data-sold-out', '');
      tile.setAttribute('aria-disabled', 'true');
    }
    tile.setAttribute('aria-pressed', 'false');
    tile.title = name;
    const links = swatchShopLinksFor(card, item, name);
    if (links.length) tile.setAttribute('data-shop-links', JSON.stringify(links));
    if (img) {
      const thumb = new Image(72, 72);
      thumb.src = imgUrlSize(img, 160);
      thumb.alt = '';
      thumb.loading = 'lazy';
      tile.append(thumb);
    } else {
      const label = document.createElement('span');
      label.className = 'swatch-sheet__tile-text';
      label.textContent = name;
      tile.append(label);
    }
    const srLabel = document.createElement('span');
    srLabel.className = 'visually-hidden';
    srLabel.setAttribute('data-swatch-tile-label', '');
    srLabel.textContent = name;
    tile.append(srLabel);
    const badge = document.createElement('span');
    badge.className = 'swatch-sheet__badge';
    badge.setAttribute('aria-hidden', 'true');
    badge.innerHTML = SWATCH_SHEET_BADGE;
    tile.append(badge);
    tiles.push(tile);
  });
  holder.replaceChildren.apply(holder, tiles);
}

$(document).on('click', '#product-grid .swatchList .item .itemBox .imgBox .view', function (event) {
  event.stopPropagation();
  const sheet = document.querySelector('[data-swatch-sheet]');
  if (!sheet || typeof window.openSwatchSheet !== 'function') return;
  const card = this.closest('.modelSection');
  const item = this.closest('.item');
  fillSwatchSheet(sheet, card);
  window.openSwatchSheet(item.dataset.color, this, { id: item.dataset.id, fabric: card.dataset.popupTitle || '' });
});

// 网格纹理角标与详情弹窗独立；document 委托兼容筛选 AJAX 和 Load More 换入的卡片。
$(document).on('click', '#product-grid .swatchList .item .itemBox .imgBox .fabric', function (event) {
  event.stopPropagation();
  const $item = $(this).closest('.item');
  if (this.disabled || $item.is('[sold_out]')) return;

  // 没有面料图就什么都别做。Liquid 那边已经不渲染这个角标了，
  // 这里再兜一手：空串经 imgUrlSize 会变成 "?width=300"，
  // 相对 URL 指回当前页面，图片直接裂掉。
  if (!$item.attr('data-fabric') || !$item.attr('data-img')) return;

  const showTexture = $(this).attr('data-type') === 'true';
  $(this).attr({
    'data-type': showTexture ? 'false' : 'true',
    'aria-pressed': showTexture ? 'true' : 'false',
    'aria-label': $(this).attr(showTexture ? 'data-label-image' : 'data-label-texture')
  });
  $(this).find('> img').attr('src', imgUrlSize($item.attr(showTexture ? 'data-img' : 'data-fabric'), 40));
  $item.find('.imgBox > img').attr('src', imgUrlSize($item.attr(showTexture ? 'data-fabric' : 'data-img'), 300));
});

// 弹窗里加入 / 移除之后：网格选中态、计数、手机底部条跟着走；选中的颜色若被一排上限收着，把卡片摊开 ——
// 关掉弹窗后网格上一张选中的卡都看不见，用户会以为刚才那下没生效。
// （已选清单本身由 cartDataChange → utils.js swatchCartChange() 重建，这里不重复。）
document.addEventListener('swatch-sheet:change', function () {
  if (typeof cartData === 'undefined' || !cartData) return;
  swatchCartChange2();
  syncSwatchBar();
  revealSelectedSwatchRows();
});

/* ------------------------------------------------------------------
   Color 筛选下的「Show all colors」

   收窄本身是 Liquid + CSS 做的（见 snippets/products-grid-swatch.liquid），
   这里只切一个 class，不请求也不改 DOM 结构。
   用事件委托绑在 document 上，所以筛选 AJAX 重渲染和 Load More
   新插进来的卡片不需要重新绑定。
   ------------------------------------------------------------------ */
$(document).on('click', '.swatchFilterNote__toggle', function (event) {
  event.preventDefault();
  event.stopPropagation();

  const $btn = $(this);
  const $card = $btn.closest('.modelSection');
  const showAll = !$card.hasClass('is-showing-all');

  $card.toggleClass('is-showing-all', showAll);
  $btn
    .text(showAll ? $btn.attr('data-label-less') : $btn.attr('data-label-more'))
    .attr('aria-expanded', showAll ? 'true' : 'false');

  // 可见集合变了 —— 一排上限要按新的集合重算（下面那条原生监听里的 render()
  // 也会走到 applyRowCap，这里再调一次是幂等的，只为不依赖两个监听器的先后顺序）。
  applyRowCap($card[0]);
});

/* ------------------------------------------------------------------
   More Colors：每块面料默认只摊一排颜色

   为什么这段必须有 JS：超出一排的判定要数「此刻**可见**的第几个」，
   而可见与否是 Color 筛选（data-color-filtered）、搜索（data-search-out）、
   「Show all N colors」（.is-showing-all）三套规则的交集。
   CSS 的 :nth-child 只认 DOM 位置、不认可见性，数不出这个序号。

   所以分工是：
   - 默认状态（没搜索、没切 show-all）由 Liquid 直接渲染好 data-row-out，
     首屏、筛选 AJAX、Load More 全都零 JS，也不会先摊开全部颜色再收起来闪一下；
   - 可见集合被 JS 改动时（搜索 / show-all），applyRowCap() 按同一规则重算。
   两边口径必须一致，否则页面一加载就会跳一下。

   展开只切 .is-expanded 一个类，不请求、不改结构。
   ------------------------------------------------------------------ */

const SWATCH_ROW_CAP = 3;      // 一排摊几个颜色（第 4 格留给 More 卡）
const SWATCH_STRIPE_CAP = 8;   // More 卡上最多画几条竖条，再多就看不清了

function applyRowCap (card) {
  const list = card && card.querySelector('.swatchList');
  if (!list) return;

  const showingAll = card.classList.contains('is-showing-all');
  const overflowIds = [];
  let rank = 0;

  list.querySelectorAll(':scope > .item').forEach(function (item) {
    // 被别的规则藏掉的不参与计数 —— 它们不占格子，跟着数会让"一排三个"变成一排一个。
    const eligible = (showingAll || item.getAttribute('data-color-filtered') !== 'out')
      && !item.hasAttribute('data-search-out');
    if (!eligible) {
      item.removeAttribute('data-row-out');
      return;
    }
    rank += 1;
    if (rank > SWATCH_ROW_CAP) {
      item.setAttribute('data-row-out', '');
      overflowIds.push(item.getAttribute('data-id'));
    } else {
      item.removeAttribute('data-row-out');
    }
  });

  const more = list.querySelector('.swatchMore');
  if (!more) return;

  if (overflowIds.length === 0) {
    // 没有可收的了（比如筛到只剩 2 个颜色）。展开态也一并清掉，
    // 否则 More 卡都藏了，用户再没有收回去的入口。
    more.hidden = true;
    card.classList.remove('is-expanded');
    const box = more.querySelector('.swatchMore__box');
    if (box) box.setAttribute('aria-expanded', 'false');
    return;
  }

  more.hidden = false;

  // ⚠ 写之前先比一次：外层 MutationObserver 观察的是 childList，
  // 改 textContent 会替换文本节点 = 一条记录 = 又一轮 render()。
  // 值没变就不写，循环自然断在这里。
  const countEl = more.querySelector('.swatchMore__count');
  if (countEl && countEl.textContent !== String(overflowIds.length)) {
    countEl.textContent = overflowIds.length;
  }

  const striped = overflowIds.slice(0, SWATCH_STRIPE_CAP);
  more.querySelectorAll('.swatchMore__stripe').forEach(function (stripe) {
    stripe.hidden = striped.indexOf(stripe.getAttribute('data-id')) === -1;
  });

  revealSelectedSwatchRows(card);
}

$(document).on('click', '.swatchMore__box', function (event) {
  event.preventDefault();
  event.stopPropagation();

  const $btn = $(this);
  const $card = $btn.closest('.modelSection');
  const expand = !$card.hasClass('is-expanded');

  $card.toggleClass('is-expanded', expand);
  $btn.attr('aria-expanded', expand ? 'true' : 'false');

  // 这里**不用**动弹窗：弹窗每次打开都按整块面料的全部颜色生成（fillSwatchSheet），网格摊开几个跟它无关。
});

// 创建观察器实例
const filterColorObserver = new MutationObserver(mutations => {
  const targetElement = document.querySelector('.facets-modal__content-wrapper');
  if (targetElement) {
    filterColorObserver.disconnect(); // 停止观察
    console.log('filterColor Load');
    // filterColorChange();
  }
});
// 配置观察选项（观察整个文档的子节点变化）
filterColorObserver.observe(document.documentElement, {
  childList: true,
  subtree: true
});

// 这里原来有两段绑在 `#FacetFiltersForm .searchBox input[type="search"]` 上的
// 按面料名过滤的代码。那个选择器在本模板下**匹配不到任何元素**：
// .searchBox 只存在于 snippets/facets-swatch.liquid（整段 render 已被注释掉）
// 和 snippets/header-left-logo.liquid（在 header 里，不在 FacetFiltersForm 内）。
// 真正的即时搜索见文件末尾的「小样页即时搜索」一节。

$(document).ready(async function () {
  await cartDataChange();
  revealSelectedSwatchRows();
  // 这里原来还调 productSingleInit()（给 .fabric 小角标填成品实拍图）。
  // 它的**定义**在 2026-08-03 的提交 de96939「更新filter」里被删了，调用却留着，
  // 于是每次打开小样页都抛 ReferenceError: productSingleInit is not defined，
  // 把这个 ready 回调后面的代码一起带走。函数没了就别再调。
  // 面料图现在只从变体 metafield custom.product_fabric_color 取。
})



$(document).on('click', '.swatchContainer .swatchCart .cartList .item', async function () {
  const id = $(this).attr('data-item-id');
  if (!id || this.dataset.removing) return;
  this.dataset.removing = 'true';
  try {
    await document.querySelector('cart-drawer-items')?.removeVariant(id);
    swatchCartChange2();
  } finally { delete this.dataset.removing; }
});

// Clear all 的撤销：把清掉的小样加回去。
//
// ⚠ 不能直接 add.js 交给 cart-flow 的上限检查：它只把"当前页面上的色块 ID + 当前购物车里的小样"
// 认作小样。从别的分页选、刚被清掉的那几片两边都不在，会被漏算 ——
// 清掉 10 片 → 再选 1 片 → Undo，就恢复成 11 片（2026-10-01 评审 P1，本地整车代码复现过）。
// 所以在队列里自己读最新购物车，按 isSwatchLineItem 数现有小样 + 要恢复的数量，超 10 直接拒绝；
// 写完再读一次核对确实全部加回，没加全就如实报。
// mutate() 走 cart-flow 的 innerRequest 通道（不再过 prepareMutation），这里就是唯一的闸门。
function restoreClearedSwatches (lines, count) {
  return CartFlow.enqueue(async ({ read, mutate }) => {
    const swatchQty = cart => (cart.items || []).filter(isSwatchLineItem).reduce((n, item) => n + item.quantity, 0);
    const before = swatchQty(await read(CartFlow.url('cart.js'), { cache: 'no-store' }));
    // 超限是"暂时不行"，不是失败：返回 refused 而不是 throw ——
    // ① CartUndo 据此保留撤销机会，用户删掉新选的之后还能再点 Undo；
    // ② enqueue 里 throw 会被 cart-flow 记成 writeFailure（"A cart change was rejected"），而这里什么都没写。
    if (before + count > 10) {
      return { refused: before === 1
        ? 'You have 1 swatch selected. Remove it, then tap Undo to restore your previous ' + count + '.'
        : 'You have ' + before + ' swatches selected. Remove ' + (before + count - 10) + ', then tap Undo to restore your previous ' + count + '.' };
    }
    await mutate(CartFlow.url('cart/add.js'), { items: lines });
    const after = swatchQty(await read(CartFlow.url('cart.js'), { cache: 'no-store' }));
    if (after !== before + count) {
      throw new Error('Only ' + Math.max(0, after - before) + ' of ' + count + ' swatches could be restored.');
    }
  });
}

// 撤销之后焦点给谁：必须是**此刻看得见**的控件。
// 移动端清单收起时 Clear all 被 CSS 藏着（没有 hidden 属性，:not([hidden]) 挑不掉它），
// 聚焦它会落空、焦点掉回 body（2026-10-01 staging 实测，评审 P2）。
// 所以按顺序找第一个有布局盒子的：Clear all（桌面 / 移动端展开）→ View（移动端收起）→ ORDER SWATCHES。
function focusVisibleSwatchCartControl () {
  const cart = document.querySelector('.swatchContainer .swatchCart');
  if (!cart) return;
  const target = ['.swatchCart__clear', '.swatchCart__toggle', '.btn']
    .map(sel => cart.querySelector(sel))
    .find(el => el && !el.hidden && el.getClientRects().length > 0 && getComputedStyle(el).visibility !== 'hidden');
  if (target) target.focus({ preventScroll: true });
}

// 一键清空已选小样（按钮在 snippets/swatch-cart.liquid）。
//
// 一次 cart/update.js 把所有免费小样行设为 0，不是逐片 removeVariant —— 10 片就是 10 个串行往返。
// ⚠ 必须放进 CartFlow.enqueue，在队列里**先读 /cart.js 再写**：
// cart-flow.js 的 prepareMutation 只给 change 做过期 key 重映射，update 不做；
// 直接拿页面上的 cartData 拼 key，折扣/赠品 App 换过 key 之后这次写就会漏删或被拒。
// 口径用 isSwatchLineItem（handle 含复数 swatches）：窗帘、$5 色卡本都留在购物车里。
//
// 不弹确认框，删完给 Undo（NN/g：可逆操作用撤销代替确认；确认框约一半是没读就点掉的）。
// Undo 用购物车同一个撤销条（component-cart-undo.js 的 CartUndo.offer），
// 加回去由 restoreClearedSwatches() 自己做 10 片上限校验（原因见那个函数的注释）。
$(document).on('click', '.swatchContainer .swatchCart .swatchCart__clear', async function (event) {
  const button = this;
  if (button.dataset.clearing || !window.CartFlow) return;
  const keyboard = event.detail === 0;   // 键盘触发的 click 没有点击次数
  button.dataset.clearing = 'true';
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');

  let removed = [];
  let failed = false;
  try {
    await CartFlow.enqueue(async ({ read, mutate }) => {
      const current = await read(CartFlow.url('cart.js'), { cache: 'no-store' });
      const lines = (current.items || []).filter(isSwatchLineItem);
      if (!lines.length) return;
      const updates = {};
      lines.forEach(item => { updates[item.key] = 0; });
      await mutate(CartFlow.url('cart/update.js'), { updates });
      removed = lines.map(item => ({
        id: item.variant_id || item.id,
        quantity: item.quantity,
        properties: item.properties || {}
      }));
    });
    await CartFlow.refresh();
  } catch (error) {
    failed = true;
    if (typeof swatchLimitNotice === 'function') {
      swatchLimitNotice(error.message || 'We could not clear your swatches. Please try again.');
    }
  } finally {
    delete button.dataset.clearing;
    button.disabled = false;
    button.removeAttribute('aria-busy');
    swatchCartChange2();
    syncSwatchBar();
  }

  // 刷新失败但写已经成功时 removed 仍然有值 —— 删掉的确实删掉了，照样给撤销
  if (!removed.length) return;
  const count = removed.reduce((total, line) => total + line.quantity, 0);
  const noun = count === 1 ? 'swatch' : 'swatches';
  if (window.CartUndo && typeof CartUndo.offer === 'function') {
    CartUndo.offer({
      message: 'Cleared ' + count + ' ' + noun + '.',
      restoredMessage: 'Restored ' + count + ' ' + noun + '.',
      restore: () => restoreClearedSwatches(removed, count),
      keyboard,
      // Undo 按钮随即隐藏，键盘用户的焦点要落到一个真看得见的控件上。
      // 用的是**按 Undo 那一下**是不是键盘（CartUndo 传进来），不是清空时的方式：鼠标清空、键盘撤销的人也要交还焦点
      onSettled ({ keyboard: undoByKeyboard } = {}) {
        swatchCartChange2();
        syncSwatchBar();
        if (undoByKeyboard) focusVisibleSwatchCartControl();
      }
    });
  } else if (!failed && typeof swatchLimitNotice === 'function') {
    swatchLimitNotice('Cleared ' + count + ' ' + noun + '.');
  }
});


function syncSwatchCardSelectionState (swatchItems) {
  $(`.modelSection .item`).removeClass('active');
  $('.swatchList .item .itemBox__select').attr('aria-pressed', 'false').each(function () {
    $(this).attr('aria-label', $(this).attr('data-label-add'));
  });
  $.each(swatchItems, function (i, item) {
    const $selectedItem = $(`.modelSection[data-id="${item.product_id}"] .item[data-color="${item.variant_title}" i]`);
    $selectedItem.addClass('active');
    $selectedItem.find('.itemBox__select').attr('aria-pressed', 'true').each(function () {
      $(this).attr('aria-label', $(this).attr('data-label-remove'));
    });
  });

  revealSelectedSwatchRows();
}

// A selected color may sit beyond the collapsed row after the initial cart
// refresh, a facet redraw, or Load More. Keep that selection visible and keep
// the disclosure control's accessibility state in sync with the card.
function revealSelectedSwatchRows (root = document) {
  const cards = root.matches && root.matches('.modelSection')
    ? [root]
    : root.querySelectorAll('.modelSection');

  cards.forEach(function (card) {
    if (!card.querySelector('.swatchList > .item.active[data-row-out]')) return;
    card.classList.add('is-expanded');
    const moreBox = card.querySelector('.swatchMore__box');
    if (moreBox) moreBox.setAttribute('aria-expanded', 'true');
  });
}

function swatchCartChange2() {
  $('.swatchList .item:not([sold_out]) .itemBox__select').removeAttr('loading').prop('disabled', false);
  const swatch = cartData.items.filter(isSwatchLineItem);
  syncSwatchCardSelectionState(swatch);

  var num = 0, str = [''];
  $.each(swatch, function (i, item) {
    num += item.quantity;
    str.push(`<button type="button" class="item" data-item-id="${item.id}">`);
    str.push(`<span class="visually-hidden">Remove swatch: </span>`);
    str.push(`<div class="itemBox">`);
    str.push(`<div class="imgBox">`);
    str.push(`<img loading="lazy" src="${imgUrlSize(item.image, 54)}" alt="" />`);
    str.push(`</div>`);
    str.push(`<div class="productTitle">`);
    str.push(`<div>`);
    str.push(`<span>${item.title.split(' ')[0]}</span>`);
    str.push(`<span>${item.variant_title}</span>`);
    str.push(`</div>`);
    str.push(`</div>`);
    str.push(`</div>`);
    str.push(`</button>`);
  });

  $('.swatchContainer .swatchCart .cartNum')
    .html(`Selected Swatches (${num} / 10)`)
    .toggleClass('is-full', num >= 10);
  // 加满之后这行说明要一直留着，不能只在点击那一下出现
  $('.swatchContainer .swatchCart .cartList .isFull').toggle(num >= 10);
  $('.swatchContainer .swatchCart .btn').css('display', num > 0 ? 'flex' : 'none');

  $('.quantity__input[aria-label*="Swatches"], .quantity__input[aria-label*="Swatches"]+button').attr('disabled', num >= 10);

}
/* ------------------------------------------------------------------
   小样页搜索
   把输入框内容拼成 `<关键词> tag:"<scope>"` 再交给 Shopify 原生搜索。
   tag: 在 Shopify 搜索里是硬性 AND 条件（实测：写一个不存在的标签返回 0 条），
   所以结果只会落在小样产品里，不需要自己实现任何匹配逻辑。

   ⚠ 搜索框**不是 <form>**，所以这里不能监听 submit。
   它渲染在 facets 的插槽里，那个位置在 <form id="FacetFiltersForm"> 内部，
   HTML 不允许 form 嵌套 —— 内层 form 会被浏览器丢掉，回车就变成提交筛选表单，
   跳回集合页并带上 ?view=swatches（页面还会改用别的模板渲染）。
   所以改成监听按钮点击 + 输入框回车，自己拼 URL 跳转。

   用事件委托绑在 document 上，筛选后重渲染栅格也不会失效。
   ------------------------------------------------------------------ */
function submitSwatchSearch (root) {
  if (!root) return;

  var input = root.querySelector('.swatch-search__input');
  var terms = (input ? input.value : '').trim();
  var scope = 'tag:"' + (root.dataset.scopeTag || '') + '"';

  var params = new URLSearchParams();
  params.set('q', terms ? terms + ' ' + scope : scope);
  params.set('type', 'product');
  params.set('options[prefix]', 'last');
  if (root.dataset.view) params.set('view', root.dataset.view);

  window.location.href = (root.dataset.searchUrl || '/search') + '?' + params.toString();
}

document.addEventListener('click', function (event) {
  var btn = event.target.closest('.swatch-search__submit');
  if (!btn) return;
  event.preventDefault();
  submitSwatchSearch(btn.closest('[data-swatch-search]'));
});

document.addEventListener('keydown', function (event) {
  if (event.key !== 'Enter') return;
  var input = event.target;
  if (!input.classList || !input.classList.contains('swatch-search__input')) return;
  // 阻止冒泡，否则回车会被外层筛选表单当成提交
  event.preventDefault();
  event.stopPropagation();
  submitSwatchSearch(input.closest('[data-swatch-search]'));
});

/* ==================================================================
   移动端小样条 / 即时搜索
   配套样式见 assets/products-grid-swatch.css 末尾两节。
   ================================================================== */

/* ---------- 移动端底部小样条 ---------- */
// .swatchCart 在 ≤960px 曾经是 display:none —— 加完小样没有计数、没有清单、
// 没有 ORDER SWATCHES 入口。现在它是固定在底部的条，一片都没选时收进屏幕外。
//
// 显隐只看「清单里有没有 .item」，不自己数购物车 —— 清单是
// utils.js 的 swatchCartChange() 和本文件的 swatchCartChange2() 重建的，
// 跟着它走就永远不会和数字对不上。
/* 条高 -> CSS 变量 --swatch-bar-h -> 页面底部留白。

   不在 CSS 里写死数字：条高随四件事变 ——
   断点（≤359px 拆三行 116px / 常规两行 80px）、
   env(safe-area-inset-bottom)（主题开了 viewport-fit=cover）、
   计数文案换不换行（"(10 / 10)" 比 "(1 / 10)" 宽）、
   以及展开/收起。

   ⚠ 用 ResizeObserver 而不是"在几个自认为关键的时刻各量一次"。
   之前那版只在 has-items 翻转和 resize 时量，漏了三条路径：
   1) 展开清单 -> 转屏（resize 时因为 is-open 直接跳过）-> 收起（收起不重量）
      => 变量停留在转屏前的值；
   2) 数量从 9 变 10 让计数换行，但 has-items 没翻转，不会重量；
   3) 筛选 AJAX 会整块换掉 #ProductGridContainer 的 innerHTML，
      .swatchCart **节点本身被换掉**，观察器会挂在一个游离节点上。
   ResizeObserver 天然覆盖 1、2；3 靠 syncSwatchBar 每次重新接线解决。

   写入是幂等的（值没变不写），所以多处调用都安全。 */
let lastBarH = 0;
let barResizeObserver = null;
let observedBarEl = null;

function writeBarHeight (h) {
  h = Math.ceil(h);
  if (h > 0 && h !== lastBarH) {
    lastBarH = h;
    document.documentElement.style.setProperty('--swatch-bar-h', h + 'px');
  }
}

function recordBarHeight (el) {
  if (!el) return;
  // 展开态量到的是"条 + 清单"，那是临时浮层高度，
  // 拿它当页面留白会让页尾突然空出一大块。只认收起态。
  if (el.classList.contains('is-open')) return;
  writeBarHeight(el.getBoundingClientRect().height);
}

function watchBarSize (el) {
  if (!el || !('ResizeObserver' in window)) return;
  if (observedBarEl === el) return;          // 已经在盯这个节点了
  if (!barResizeObserver) {
    barResizeObserver = new ResizeObserver(function (entries) {
      const target = observedBarEl;
      if (!target || target.classList.contains('is-open')) return;
      const entry = entries[entries.length - 1];
      // borderBoxSize 含 padding（安全区就在 padding 里），contentRect 不含 ——
      // 这里必须用前者，回退到 getBoundingClientRect 而不是 contentRect。
      if (entry.borderBoxSize && entry.borderBoxSize.length) {
        writeBarHeight(entry.borderBoxSize[0].blockSize);
      } else {
        writeBarHeight(target.getBoundingClientRect().height);
      }
    });
  }
  if (observedBarEl) barResizeObserver.unobserve(observedBarEl);
  observedBarEl = el;
  barResizeObserver.observe(el);
}

// 收起的清单要同时对读屏隐藏。
// max-height:0 + overflow:hidden 只是**视觉**裁掉，节点仍在可访问性树里：
// 读屏会把已选小样一条条念出来，而按钮上写的是 "View"（=还没展开），自相矛盾。
// 桌面端不能加 —— 那里清单是常驻侧栏，本来就该读得到。
// 清单项现在是可键盘删除的 button，因此收起时除了 aria-hidden 还必须 inert；
// tabindex 兜底照顾不支持 inert 的旧浏览器。
function syncCartListA11y ($cart) {
  const list = $cart.find('.cartList')[0];
  if (!list) return;
  const hidden = isMobileSwatch() && !$cart.hasClass('is-open');
  const controls = list.querySelectorAll('button, a[href], [tabindex]');

  if (hidden) {
    list.setAttribute('aria-hidden', 'true');
    list.inert = true;
    controls.forEach(function (control) {
      if (!control.hasAttribute('data-swatch-tabindex')) {
        control.setAttribute('data-swatch-tabindex', control.getAttribute('tabindex') || '');
      }
      control.setAttribute('tabindex', '-1');
    });
  } else {
    list.removeAttribute('aria-hidden');
    list.inert = false;
    controls.forEach(function (control) {
      if (!control.hasAttribute('data-swatch-tabindex')) return;
      const original = control.getAttribute('data-swatch-tabindex');
      if (original) control.setAttribute('tabindex', original);
      else control.removeAttribute('tabindex');
      control.removeAttribute('data-swatch-tabindex');
    });
  }
}

function syncSwatchBar () {
  const $cart = $('.swatchContainer .swatchCart');
  if (!$cart.length) return;

  const lineCount = $cart.find('.cartList .item').length;
  const hasItems = lineCount > 0;
  $cart.toggleClass('has-items', hasItems);
  // "Clear all" 2 片及以上才出现；正在清空时别让它闪回来
  $cart.find('.swatchCart__clear').each(function () {
    if (!this.dataset.clearing) this.hidden = lineCount < 2;
  });
  // 条会盖住最后一排卡片，有内容时才给页面补底部留白
  $('body').toggleClass('has-swatch-bar', hasItems);

  // 节点可能刚被筛选 AJAX 换成新的，每次都重新接线（同一个节点会直接返回）
  watchBarSize($cart[0]);
  syncCartListA11y($cart);
  // 没有 ResizeObserver 的老浏览器靠这一次兜底
  if (hasItems && !barResizeObserver) recordBarHeight($cart[0]);

  if (!hasItems) {
    $cart.removeClass('is-open');
    const $toggle = $cart.find('.swatchCart__toggle');
    $toggle.attr('aria-expanded', 'false');
    // 文案也得跟着复位。否则：展开清单 → 删光最后一片 → 再加一片，
    // 条是收起状态，按钮上却还写着 "Hide"。
    const $label = $toggle.find('.swatchCart__toggle-label');
    const nextLabel = $label.attr('data-label-more') || '';
    if ($label.text() !== nextLabel) $label.text(nextLabel);
  }
}

// 转屏会跨 359px 断点（两行 <-> 三行），安全区也会变，条高跟着变，
// 页面留白必须重量一次。防抖是因为 resize 在转屏过程中会连续触发。
let swatchBarResizeTimer = null;
window.addEventListener('resize', function () {
  if (swatchBarResizeTimer) clearTimeout(swatchBarResizeTimer);
  swatchBarResizeTimer = setTimeout(function () {
    swatchBarResizeTimer = null;
    const $cart = $('.swatchContainer .swatchCart');
    if ($cart.length) syncCartListA11y($cart);   // 跨 960px 断点时可读性要求相反
    if ($cart.length && $cart.hasClass('has-items')) recordBarHeight($cart[0]);
  }, 200);
});

$(document).on('click', '.swatchContainer .swatchCart .swatchCart__toggle', function () {
  const $cart = $(this).closest('.swatchCart');
  const open = !$cart.hasClass('is-open');
  $cart.toggleClass('is-open', open);
  $(this).attr('aria-expanded', open ? 'true' : 'false');

  const $label = $(this).find('.swatchCart__toggle-label');
  $label.text(open ? $label.attr('data-label-less') : $label.attr('data-label-more'));

  syncCartListA11y($cart);

  // 收起之后重量一次：展开期间可能转过屏，那时 is-open 让测量被跳过。
  // .cartList 的 max-height 有 0.25s 过渡，要等它走完才量得到收起后的高度。
  // 有 ResizeObserver 时它自己也会补一次，这里是老浏览器的兜底，写入幂等不冲突。
  if (!open) {
    const el = $cart[0];
    setTimeout(function () { recordBarHeight(el); }, 300);
  }
});

/* ---------- 小样页即时搜索 ---------- */
/*
   为什么要改：搜索框渲染在 <form id="FacetFiltersForm"> 内部（那是唯一能让它和
   ALL FILTERS 同排且自带 sticky 的位置，见 snippets/swatch-search-form.liquid 的注释），
   而 assets/facets.js:11 对整个表单绑了 input 事件 —— **每敲一个字都触发一次筛选 AJAX**。
   实测（2026-09-07 线上，iPhone 390x844）：输入 velvet 之后 URL 被改写成 `?&`，
   .loading-overlay（rgba(255,255,255,.7)，350x48257）铺满整个网格并且再也不消失，
   页面看上去就是卡死变灰。桌面端一模一样。

   两件事：
   1) 在 document 的**捕获阶段**把 input 事件截住 stopPropagation ——
      捕获阶段先于表单的冒泡监听，事件根本到不了 facets.js，灰屏和多余请求一起没了。
      必须是捕获阶段：绑在输入框上的冒泡监听拦不住已经在向上走的事件。
   2) 用截住的这个事件做页内即时收窄：零请求、零跳转。

   为什么还留着「跳到 /search」：本页 paginate 是 36 条，而小样全集有 80+，
   页内搜只能搜到已加载的那些。所以状态行里永远给一个 Search all swatches 的出口。
*/
// 页内即时收窄的最小字数。回车处理（文件末尾）也要用同一个值 ——
// 两处不一致会出现「页内没筛、回车也被拦下」的死路。
const SWATCH_SEARCH_MIN_CHARS = 2;

(function swatchInstantSearch () {
  const MIN_CHARS = SWATCH_SEARCH_MIN_CHARS;
  const DEBOUNCE_MS = 120;

  let activeQuery = '';
  let timer = null;
  let applying = false;

  function norm (value) {
    return (value || '').toLowerCase().replace(/\s+/g, ' ').trim();
  }

  function searchRoot () {
    return document.querySelector('[data-swatch-search]');
  }

  function gridBox () {
    return document.querySelector('#product-grid .swatchBox');
  }

  // 和 submitSwatchSearch 用同一套拼装规则，避免两处漂移
  function allResultsUrl (terms) {
    const root = searchRoot();
    if (!root) return '/search';
    const scope = 'tag:"' + (root.dataset.scopeTag || '') + '"';
    const params = new URLSearchParams();
    params.set('q', terms ? terms + ' ' + scope : scope);
    params.set('type', 'product');
    params.set('options[prefix]', 'last');
    if (root.dataset.view) params.set('view', root.dataset.view);
    return (root.dataset.searchUrl || '/search') + '?' + params.toString();
  }

  // 状态行。挂在搜索框内部，跟着 sticky 一起走。
  function livePanel () {
    const root = searchRoot();
    if (!root) return null;

    let panel = root.querySelector('.swatch-search__live');
    if (panel) return panel;

    panel = document.createElement('div');
    panel.className = 'swatch-search__live';
    panel.setAttribute('role', 'status');
    panel.setAttribute('aria-live', 'polite');
    panel.hidden = true;
    panel.innerHTML =
      '<span class="swatch-search__live-count"></span>'
      + '<button type="button" class="swatch-search__live-clear">Clear</button>'
      + '<a class="swatch-search__live-all" href="#"></a>';
    root.appendChild(panel);
    return panel;
  }

  function clearEmptyState () {
    const box = gridBox();
    if (!box) return;
    const el = box.querySelector('.swatch-search__empty');
    if (el) el.remove();
  }

  // ⚠ 必须幂等：同样的关键词反复调用不能产生任何 DOM 变动。
  // 之前是每次 clearEmptyState() 再重新 append，而下面那个 MutationObserver 盯着
  // #ProductGridContainer 的 childList/subtree —— 观察器回调是**微任务**，
  // 跑的时候 applying 早已被同步代码复位成 false，所以那个 guard 根本挡不住自己，
  // 于是「插节点 → 观察器 → render → 再插节点」每帧一轮转个不停。
  // 线上实测（2026-09-07，零结果关键词 zzqq）：3 秒内 300+ 次 mutation，永不停；
  // 有结果时是 0。移动端就是白白烧 CPU 和电。
  function showEmptyState (terms) {
    const box = gridBox();
    if (!box) return;

    let wrap = box.querySelector('.swatch-search__empty');
    if (!wrap) {
      wrap = document.createElement('div');
      wrap.className = 'swatch-search__empty';
      wrap.appendChild(document.createElement('p'));
      wrap.appendChild(document.createElement('a'));
      box.appendChild(wrap);
    }

    const p = wrap.querySelector('p');
    const a = wrap.querySelector('a');
    const msg = 'No swatches on this page match “' + terms + '”.';
    const cta = 'Search all swatches for “' + terms + '” →';
    const href = allResultsUrl(terms);

    // 逐项比对再写，值没变就一个字节都不动
    if (p.textContent !== msg) p.textContent = msg;
    if (a.textContent !== cta) a.textContent = cta;
    if (a.getAttribute('href') !== href) a.setAttribute('href', href);
  }

  // 收窄本体。只打属性 + 切一个类，藏由 CSS 负责 ——
  // 和 Color 筛选的 data-color-filtered 是两套独立规则，不会互相覆盖。
  function apply (query) {
    const box = gridBox();
    if (!box) return { fabrics: 0, colors: 0 };

    const cards = box.querySelectorAll('.modelSection');
    if (!query) {
      box.classList.remove('is-searching');
      cards.forEach(function (card) {
        card.removeAttribute('data-search-out');
        card.removeAttribute('data-search-narrow');
        card.querySelectorAll('[data-search-out]').forEach(function (el) {
          el.removeAttribute('data-search-out');
        });
        // 清空关键词后可见集合回到"只受 Color 筛选影响"，一排上限跟着回算
        applyRowCap(card);
      });
      clearEmptyState();
      return { fabrics: 0, colors: 0 };
    }

    box.classList.add('is-searching');

    let fabricHits = 0;
    let colorHits = 0;

    // 先整句匹配（原来的规则），整句在这批卡片里一个都没命中、且不止一个词时，
    // 才退到逐词匹配：每个词都要是「面料名 + 颜色名」里某个词的词头 —— "blue velvet" 靠这条。
    // 逐词不看描述（满是 light filtering / thermal 这类词）、连字符当空格（grey-blue 算两个词）。
    // 不能一上来就逐词："light blue" 逐词会把 dark blue / stone blue 都捞进来
    //（light 撞上 Lightweight、描述里的 light filtering），整句只命中真正的 Light Blue。
    // ⚠ 规则必须和 sections/swatch-search-results.liquid 的 kw_filter 一致，
    // 结果页是服务端先按同一规则筛、加载后这里再收窄色块，两边不一致计数就对不上。
    const tokens = query.split(' ');
    function hasAllHeads (text) {
      const padded = ' ' + text.replace(/-/g, ' ').replace(/\s+/g, ' ');
      for (let i = 0; i < tokens.length; i += 1) {
        if (padded.indexOf(' ' + tokens[i]) === -1) return false;
      }
      return true;
    }
    function nameTextOf (card) {
      const nameEl = card.querySelector('.sectionTitle h2');
      return norm((card.getAttribute('data-title') || '') + ' ' + (nameEl ? nameEl.textContent : ''));
    }
    function fabricTextOf (card) {
      const titleEl = card.querySelector('.sectionTitle');
      return norm(
        (card.getAttribute('data-title') || '') + ' ' + (titleEl ? titleEl.textContent : '')
      );
    }
    function isVisible (card, item) {
      return card.classList.contains('is-showing-all') || item.getAttribute('data-color-filtered') !== 'out';
    }
    let byPhrase = true;
    if (tokens.length > 1) {
      byPhrase = [].some.call(cards, function (card) {
        const fabricHit = fabricTextOf(card).indexOf(query) !== -1;
        return [].some.call(card.querySelectorAll('.swatchList .item'), function (item) {
          return isVisible(card, item)
            && (fabricHit || norm(item.getAttribute('data-color')).indexOf(query) !== -1);
        });
      });
    }

    cards.forEach(function (card) {
      const fabricText = fabricTextOf(card);
      const nameText = byPhrase ? '' : nameTextOf(card);
      const fabricMatch = byPhrase ? fabricText.indexOf(query) !== -1 : hasAllHeads(nameText);

      // Color 筛选把没命中的变体标成 data-color-filtered="out"（Liquid 打的），
      // CSS 在卡片没有 .is-showing-all 时把它们藏掉。搜索必须认这个状态，
      // 否则「先筛 Brown 再搜 Blue」会剩一张两套规则各藏一半、里面空无一物的卡片，
      // 状态行还照报「1 fabric · 1 color」—— 两套规则取交集却按并集计数。
      //
      // 语义定为**交集**：筛选是用户自己设的，搜索在它之上继续收窄，不偷偷绕过它。
      // 搜不到时空态里的 "Search all swatches" 就是出口。
      const showingAll = card.classList.contains('is-showing-all');

      const items = card.querySelectorAll('.swatchList .item');
      // 「命中且此刻真看得见」的数量。卡片显不显示、状态行报多少，都只认它。
      let visibleHits = 0;

      items.forEach(function (item) {
        const color = norm(item.getAttribute('data-color'));
        const hit = fabricMatch || (byPhrase ? color.indexOf(query) !== -1 : hasAllHeads(nameText + ' ' + color));
        if (hit) {
          // data-search-out 只表达"关键词没命中"，不掺 Color 筛选的状态 ——
          // 这样用户点「Show all N colors」时，命中关键词但之前被筛选藏着的色块能露出来。
          item.removeAttribute('data-search-out');
          if (showingAll || item.getAttribute('data-color-filtered') !== 'out') {
            visibleHits += 1;
          }
        } else {
          item.setAttribute('data-search-out', '');
        }
      });

      if (visibleHits === 0) {
        card.setAttribute('data-search-out', '');
        card.removeAttribute('data-search-narrow');
      } else {
        card.removeAttribute('data-search-out');
        // 面料名本身命中就整块摊开，不做卡内收窄
        if (fabricMatch) {
          card.removeAttribute('data-search-narrow');
        } else {
          card.setAttribute('data-search-narrow', '');
        }
        fabricHits += 1;
        colorHits += visibleHits;
      }

      // 命中集合就是新的可见集合，一排上限、More 卡的数字和竖条都按它重算。
      // 注意状态行的 colorHits 报的是"匹配到几个颜色"，不减去被收起来的那些 ——
      // 收窄是展示折叠，不是筛选。
      applyRowCap(card);
    });

    return { fabrics: fabricHits, colors: colorHits };
  }

  function render () {
    const panel = livePanel();
    const terms = activeQuery;

    if (!terms) {
      apply('');
      if (panel) panel.hidden = true;
      return;
    }

    // 小样搜索结果页：服务端已经按同一个关键词筛好，状态行（.swatch-search__status）
    // 报了准确条数，这里只做卡内色块收窄，不再叠一条「N fabrics · Search all swatches →」——
    // 那个链接指向的就是当前页。用户改了关键词才重新出现。
    const root = searchRoot();
    if (root && root.dataset.serverTerms && norm(root.dataset.serverTerms) === terms) {
      apply(terms.length < MIN_CHARS ? '' : terms);
      if (panel) panel.hidden = true;
      clearEmptyState();
      return;
    }

    // 只输了 1 个字符：页内不收窄（一个字母能命中几乎所有面料，筛了等于没筛，
    // 还要白跑一遍全卡遍历）。但**必须给一个看得见的出口** ——
    // ≤749px 时 SEARCH 按钮是隐藏的，如果这里什么都不显示，
    // 手机用户输一个字符就只剩回车，而回车以前也被拦下，等于死路。
    if (terms.length < MIN_CHARS) {
      apply('');
      if (panel) {
        const hintCount = panel.querySelector('.swatch-search__live-count');
        const hintAll = panel.querySelector('.swatch-search__live-all');
        if (hintCount) hintCount.textContent = 'Keep typing to filter this page';
        if (hintAll) {
          hintAll.href = allResultsUrl(terms);
          hintAll.textContent = 'Search all swatches →';
        }
        panel.hidden = false;
      }
      return;
    }

    const stats = apply(terms);

    if (panel) {
      const count = panel.querySelector('.swatch-search__live-count');
      const all = panel.querySelector('.swatch-search__live-all');
      if (count) {
        count.innerHTML = stats.fabrics
          ? '<b>' + stats.fabrics + '</b> ' + (stats.fabrics === 1 ? 'fabric' : 'fabrics')
            + ' · <b>' + stats.colors + '</b> ' + (stats.colors === 1 ? 'color' : 'colors')
          : 'No matches on this page';
      }
      if (all) {
        all.href = allResultsUrl(terms);
        all.textContent = 'Search all swatches →';
      }
      panel.hidden = false;
    }

    if (stats.fabrics === 0) {
      showEmptyState(terms);
    } else {
      clearEmptyState();
    }
  }

  // 取消尚未触发的防抖，立刻按给定值渲染一次。
  // 用在"用户已经明确表示输完了"的时刻（现在只有回车）。
  function flushPending (value) {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
    activeQuery = norm(value);
    applying = true;
    render();
    applying = false;
  }

  function schedule () {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      timer = null;
      applying = true;
      render();
      applying = false;
    }, DEBOUNCE_MS);
  }

  // 捕获阶段 + stopPropagation：这是修「打字整页变灰」的那一行。
  // facets.js 把 input 监听绑在 <form id="FacetFiltersForm"> 上（冒泡阶段），
  // 我们的搜索框是它的后代，不截住的话每敲一个字都会触发一次筛选 AJAX。
  document.addEventListener('input', function (event) {
    const el = event.target;
    if (!el || !el.classList || !el.classList.contains('swatch-search__input')) return;
    event.stopPropagation();
    activeQuery = norm(el.value);
    schedule();
  }, true);

  /* ---------- 回车：有页内结果就只收键盘，没有才跳全站搜索 ---------- */
  // 放在 IIFE 里面（不是文件末尾）是为了能拿到 timer / activeQuery / render，
  // 从而在判断前把待处理的防抖同步跑完 —— 见下面 flushPending 的说明。
  //
  // 仍然用捕获阶段：文件前面那个跳 /search 的 keydown 是冒泡阶段绑的，
  // 捕获总是先跑，这里不拦就自然落到它手里。
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    const input = event.target;
    if (!input.classList || !input.classList.contains('swatch-search__input')) return;

    const terms = (input.value || '').trim();

    // 一个字都没输：没什么可搜的，收起键盘就行，别跳去 /search 看全部
    if (!terms) {
      event.preventDefault();
      event.stopPropagation();
      input.blur();
      return;
    }

    // ⚠ 不足 MIN_CHARS 时**必须放行**给 submitSwatchSearch 走整页搜索。
    // 这时页内没有做任何收窄（卡片全在），下面的 hasVisible 判断必然为真，
    // 一律拦下来只 blur 的话：没有页内筛选、没有整页搜索，而 ≤749px 的 SEARCH
    // 按钮又是隐藏的 —— 手机上输一个字符按键盘"搜索"完全没反应，是条死路。
    if (terms.length < MIN_CHARS) return;

    // ⚠ 判断前必须把防抖同步跑完。
    // 输入是 DEBOUNCE_MS(120ms) 防抖的，而这里读的是 DOM 里**当前**的可见卡片。
    // 打完最后一个字符立刻回车（<120ms）时，DOM 还停在**上一个关键词**的结果上，
    // 于是按旧结果决定去留，两个方向都会错：
    //   linen(22 条) -> 改成 zzqq 立刻回车：以为还有结果，只 blur，不跳转；
    //   zzqq(0 条)   -> 改成 linen 立刻回车：以为没结果，白白整页跳走 1.6MB。
    // 同步跑一遍很便宜，而且用户已经停下来按回车了，没有继续输入要防的。
    flushPending(input.value);

    const box = document.querySelector('#product-grid .swatchBox');
    const hasVisible = box && box.querySelector('.modelSection:not([data-search-out])');
    if (!hasVisible) return; // 一条都没命中，交给原有的 submitSwatchSearch

    event.preventDefault();
    event.stopPropagation();
    input.blur();
  }, true);

  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;

    if (event.target.closest('.swatch-search__live-clear')) {
      event.preventDefault();
      const input = document.querySelector('.swatch-search__input');
      if (input) input.value = '';
      activeQuery = '';
      render();
      return;
    }

    // 「Show all N colors」会改变哪些色块看得见，而搜索的命中数只认看得见的那些
    //（见 apply() 里 visibleHits 的注释），所以要整体重算一遍。
    // 这个原生监听跑在同为 document 委托的 jQuery 处理器之后（那个注册得更早），
    // 所以到这里 .is-showing-all 已经切好了。
    const noteToggle = event.target.closest('.swatchFilterNote__toggle');
    if (noteToggle) {
      applying = true;
      render();
      applying = false;
    }
  });

  // 筛选 AJAX 会整块换掉 #ProductGridContainer 的 innerHTML，
  // Load More 会往 .swatchBox 里追加卡片 —— 两种情况下新卡片都不带收窄属性。
  // 这里统一在 DOM 变化后按当前关键词重跑一遍，不用去改 facets.js / load-more.js。
  const gridContainer = document.getElementById('ProductGridContainer');
  if (gridContainer && 'MutationObserver' in window) {
    let pending = false;
    new MutationObserver(function (records) {
      // ⚠ 底部条的显隐必须**无条件**跟着购物车清单走，绝不能和下面搜索那套
      // 节流/过滤共用一条路径：记录一旦被 applying 或 relevant 判掉，
      // MutationObserver **不会补发**，条就永久停在"已加购但没出现"的状态 ——
      // 用户加了小样却看不到计数和 ORDER SWATCHES，正是这次整改要修的那个病。
      // 这一句很便宜：清单最多 10 条，只做一次 querySelectorAll + 两个 class 切换。
      syncSwatchBar();

      if (applying || pending) return;

      // ⚠ applying 这个同步标志挡不住自己造成的变化：观察器回调是微任务，
      // 轮到它跑的时候 render() 早已返回、applying 已经复位成 false。
      // 所以必须按记录内容过滤 —— 只由自己插的空态节点引起的变化一律不算"网格变了"。
      // showEmptyState 已经做成幂等，这里是第二道闸：首次插入和换关键词时
      // 仍会产生记录，不滤掉就要白跑一轮全卡遍历。
      const relevant = records.some(function (rec) {
        const t = rec.target;
        if (t && t.nodeType === 1 && t.closest && t.closest('.swatch-search__empty, .swatchCart')) return false;
        const touched = [].slice.call(rec.addedNodes).concat([].slice.call(rec.removedNodes));
        if (!touched.length) return true;
        return touched.some(function (n) {
          return !(n.nodeType === 1 && n.classList && n.classList.contains('swatch-search__empty'));
        });
      });
      if (!relevant) return;

      // 筛选 AJAX / Load More 新插入的卡片来自 Liquid，默认都是未选状态；
      // 只补卡片状态，不重写 cartList/cartNum（后者会再制造 childList 记录）。
      const addedCards = records.some(function (rec) {
        return [].some.call(rec.addedNodes, function (node) {
          return node.nodeType === 1 && (
            node.matches('.modelSection') || (node.querySelector && node.querySelector('.modelSection'))
          );
        });
      });
      if (addedCards) syncSwatchCardSelectionState(cartData.items.filter(isSwatchLineItem));

      pending = true;
      requestAnimationFrame(function () {
        pending = false;
        applying = true;
        const input = document.querySelector('.swatch-search__input');
        if (!input) {
          activeQuery = '';
        } else if (document.activeElement !== input) {
          // 筛选重渲染可能把输入框换成一个空的，以 DOM 为准
          activeQuery = norm(input.value);
        }
        render();
        applying = false;
      });
    }).observe(gridContainer, { childList: true, subtree: true });
  }

  $(document).ready(function () {
    const input = document.querySelector('.swatch-search__input');
    if (input) activeQuery = norm(input.value);
    render();
    syncSwatchBar();
  });
})();
